'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderStatus = exports.getDispatchType = exports.isDispatchType = exports.predictTime = exports.dispatchTime = exports.overtime = exports.isBookedOrder = exports.ORDER_STATUS_LABEL = undefined;

var _time = require('./time');

var _order = require('../constants/order.js');

var ONE_HOUR = 60 * 60 * 1000;
var FIVE_MINUTES = 5 * 60 * 1000;
var TEN_MINUTES = 10 * 60 * 1000;
var FIVETEEN_MINUTES = 15 * 60 * 1000;
var TWENTY_MINUTES = 20 * 60 * 1000;
var THIRTY_MINUTES = 30 * 60 * 1000;

// apollo 订单状态码
var ORDER_STATUS_LABEL = exports.ORDER_STATUS_LABEL = {
  0: '呼单',
  10: '待指派',
  20: '待到店',
  80: '待取餐',
  30: '配送中',
  40: '配送完成',
  60: '配送取消',
  70: '配送异常',
  90: '配送失败'
};

/**
 * 是否是预订单
 * @param {Object} order
 */
var isBookedOrder = exports.isBookedOrder = function isBookedOrder(order) {
  var nowAt = (0, _time.now)();
  return !!order.scheduleDeliveryTime && order.scheduleDeliveryTime - nowAt >= ONE_HOUR;
};

/**
 * 计算超时时间
 * @param {Object} order
 */
var overtime = exports.overtime = function overtime(order) {
  /**
   * deliverType:
   * 1: 普通订单
   * 2：预订单
   */
  var nowAt = (0, _time.now)();
  var duration = 0;
  var endTime = '';
  switch (order.state) {
    case _order.ORDER_STATUS.ACCEPT:
    case _order.ORDER_STATUS.ASSIGN:
    case _order.ORDER_STATUS.ARRIVAL:
    case _order.ORDER_STATUS.FETCH:
      endTime = nowAt;
      break;
    case _order.ORDER_STATUS.COMPLETE:
      endTime = order.completeTime;
      break;
    case _order.ORDER_STATUS.CANCEL:
    case _order.ORDER_STATUS.EXCEPTION:
    case _order.ORDER_STATUS.FAIL:
      endTime = order.exceptionTime;
      break;
    default:
      break;
  }

  if (!endTime) {
    if (order.orderEvents && order.orderEvents.length > 0) {
      endTime = order.orderEvents[order.orderEvents.length - 1].ocurredTime;
    } else {
      endTime = nowAt;
    }
  }
  if (order.deliverType === 1) {
    duration = order.predictDeliveryAt - endTime;
  } else {
    duration = order.scheduleDeliveryTime + TWENTY_MINUTES - endTime;
  }

  var isOverTime = duration <= 0;
  var isWarming = isOverTime || duration <= FIVETEEN_MINUTES;
  var label = isOverTime ? '已超时' : '距超时';
  label = label + ' ' + (0, _time.durationFormat)(duration);

  var html = '<span style="' + (isWarming ? 'color: red' : '') + '">' + label + '</span>';

  return {
    duration: duration,
    label: label,
    isOverTime: isOverTime,
    html: html,
    isWarming: isWarming
  };
};

/**
 * 计算调度时间
 * @param {Object} order
 */
var dispatchTime = exports.dispatchTime = function dispatchTime(order) {
  var nowAt = (0, _time.now)();
  var duration = nowAt - order.acceptTime;
  var label = (0, _time.durationFormat)(duration);
  var color = 'initial';

  if (order.deliveryType === 1) {
    if (duration < FIVETEEN_MINUTES) {
      color = '#f00';
    } else if (duration >= FIVETEEN_MINUTES && duration <= THIRTY_MINUTES) {
      color = '#ffa500';
    } else {
      color = '#008000';
    }
  } else {
    if (duration < TEN_MINUTES) {
      color = '#008000';
    } else if (duration >= TEN_MINUTES && duration <= FIVE_MINUTES) {
      color = '#ffa500';
    } else {
      color = '#f00';
    }
  }

  var html = '<span style="color: ' + color + '">' + label + '</span>';
  return {
    duration: duration,
    label: label,
    html: html,
    color: color
  };
};

/**
 * 预计达到时间
 * @param {Object} order
 */
var predictTime = exports.predictTime = function predictTime(order) {
  return order.deliverType === 1 ? order.predictDeliveryAt : order.scheduleDeliveryTime;
};

/**
 * 判断是否是正在指派 / 预指派 / 待手工指派 / 智能超时 的订单
 * @param {Object} order
 */
var isDispatchType = exports.isDispatchType = function isDispatchType(order, type) {
  var nowAt = (0, _time.now)();
  var isTimeout = nowAt > order.intelligentTimeout;

  switch (type) {
    // 待手工指派
    case 'wait_manual_assign':
      return !order.intelligentOrder || isTimeout;
    // 智能调度中
    case 'scheduling':
      return order.intelligentOrder && !isTimeout;
    case 'appoint':
      return !order.scheduleDeliveryTime || !isBookedOrder(order);
    case 'disappoint':
      return !!order.scheduleDeliveryTime && isBookedOrder(order);
    default:
      return false;
  }
};

var getDispatchType = exports.getDispatchType = function getDispatchType(order, intelligentSwitch) {
  var types = [];

  if (intelligentSwitch) {
    types = ['wait_manual_assign', 'scheduling'];
  } else {
    types = ['appoint', 'disappoint'];
  }

  for (var i = 0; i < types.length; i++) {
    if (isDispatchType(order, types[i])) {
      return types[i];
    }
  }

  return '';
};

/**
 * 订单状态
 * @param {Object} order
 */
var orderStatus = exports.orderStatus = function orderStatus(state) {
  return {
    state: state,
    label: ORDER_STATUS_LABEL[state]
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/components/order-dialog/src/utils/order.js
// module id = 301
// module chunks = 0